<style lang="scss" scoped>

    .video-player-container {
        position:relative;
        height: 480px;
    }

    .instructions {
        font-weight: bold;
        color: #4d8ab7;
        font-size: 1.2em;
    }

    #video-player {
        width: 100%;
        height: 100%;
    }
</style>

<template>
	<div>
        <div class="instructions mb-4">
	        <slot name="instructions">
	            Click Play to start the training overvideo video.
	        </slot>
	    </div>

		<div class='video-player-container'>

			<div id='video-player'></div>

		</div>
	</div>
</template>

<script>

	import { mapState } from 'vuex';

	export default {
		props: ['programId'],
		data() {
			return {
				embedVideo: null,
				interval: null,
				intervalDuration: 500,
				isQuestionBlockDisplayed: false,
				isContinueButtonDisplayed: false,
				feedbackText: "",
				externalLoaded: false,
				sessionId: "fe232893-71db-46d4-81a9-a8ea0108a934",
			};
		},

		methods: {

	        onPanoptoEmbedApiReady: function() {
	        	// axios.get('/build-the-skills/video/program' + this.programdId).then(response => {

		            this.embedVideo = new EmbedApi("video-player", {
		                width: "100%",
		                height: "100%",
		                //This is the URL of your Panopto site
		                serverName: "uncch.hosted.panopto.com",
		                sessionId: this.sessionId,
		                videoParams: { // Optional parameters
		                //interactivity parameter controls if the user sees table of contents, discussions, notes, & in-video search
		                    "interactivity": "none",
		                    "showtitle": "true"
		                },
		                events: {
		                    "onIframeReady": this.onPanoptoIframeReady,
		                    "onReady": this.onPanoptoVideoReady,
		                    "onStateChange": this.onPanoptoStateUpdate,
		                    "onError": this.onPanoptoError
		                }
		            });

        		// });
	        },

	        onPanoptoError: function() {
	        },

	        onPanoptoIframeReady: function() {
	            // The iframe is ready and the video is not yet loaded (on the splash screen)
	            // Load video will begin playback
	            this.embedVideo.loadVideo();
	        },

	        onPanoptoVideoReady: function() {
	            // The video has successfully been loaded by onPanoptoIframeReady

	        },

         	onPanoptoStateUpdate: function(state) {
	            if (state === PlayerState.Playing) {
	            	this.onPlayingStatusUpdate();
	            } else if(state === PlayerState.Paused) {
	            	this.onPausedStatusUpdate();
	            }
	        },

	        /**
	         * Handler for PLAYING status
	         */
	        onPlayingStatusUpdate() {
			},

	        /**
	         * Handler for PAUSED status
	         */
	        onPausedStatusUpdate() {
	        },

	        onClickAnswer: function (event) {
	        	this.continueVideo();
	        },

	        continueVideo: function() {
	        	this.embedVideo.playVideo();
	        },
		},
		computed: {
		},
		watch: {
		},
		mounted() {
			this.onPanoptoEmbedApiReady();
		}
	}
</script>
